import Icon from '../components/Icon.vue'

Icon.register({"wrench":{"width":512,"height":512,"paths":[{"d":"M481.2 200C490.5 200 496.3 210.2 491.5 218.1 466.3 260 420.4 288 368 288 288.8 288 224.5 224 224 144.9 223.5 65.5 288.5 0 368 0 420.4 0 466.2 27.9 491.4 69.7 496.2 77.8 490.5 88 481.2 88H376L336 144 376 200H481.2zM309.5 293L109.3 493.3C84.3 518.2 43.7 518.2 18.7 493.3-6.2 468.3-6.2 427.7 18.7 402.7L219 202.5C235.2 243.7 268.3 276.8 309.5 293zM104 432C104 418.7 93.3 408 80 408S56 418.7 56 432 66.7 456 80 456 104 445.3 104 432z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/wrench.js
// module id = null
// module chunks = 